<template>
  <div class="logistics">
    <div
      class="header acea-row row-between row-top"
      v-for="(cart,ind) in list"
      :key="ind"
      style="padding: 0.23rem 0rem;background-color: #fff;"
      :class="ind == list.length-1 ? '':'alone'"
    >
      <template>
        <div class="pictrue"><img :src="cart.pic" /></div>
          <div class="text acea-row row-between modulListTitle">
            <div class="name line2">
              {{ cart.name }}
            </div>
            <div class="money">
              <div>x{{ cart.num }}</div>
            </div>
          </div>
      </template>


<!-- 物流信息 -->
    <div class="logisticsCon" v-if='cart.oldwuliu && cart.oldwuliu.length != 0'>
            <div class="company acea-row row-between-wrapper wuliu-detail">
        <div class="picTxt acea-row row-between-wrapper aloneWuliu">
          <div class="iconfont icon-wuliu"></div>
          <div class="text aloneWuliuInfo">
            <div>
              <span class="name line1"
                >物流公司：{{ cart.oldwuliu.delivery_name }}</span
              >
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span> {{ cart.oldwuliu.delivery_id }}
            </div>
          </div>
        </div>
        <div
          class="copy acea-row row-center-wrapper copy-data"
          :data-clipboard-text="cart.oldwuliu.delivery_id"
        >
          复制单号
        </div>
        <div v-if='cart.express' class="details">
            <div class="xq" @click="isshow(ind)">
              <span v-if="!cart.is_show">点击查看详情</span>
              <span class="down" v-if="!cart.is_show">︾</span>

              <span v-if="cart.is_show">收起</span>
              <span class="down" v-if="cart.is_show">︽</span>
            </div>
        </div>
      </div>
        <div v-if='cart.is_show'>
      <div class="item xq" v-if='cart.express.status !== "0"' >
        :( 暂未查到与您单号相关的物流信息，请稍后再尝试。
      </div>
      <div class="item wuLiu-InfoModul" v-else-if="cart.is_show" v-for="(express, index) in cart.express.result.list" :key="index" >
        <div class="circular" :class="index === 0 ? 'on' : ''"></div>
        <div class="text wuliu-Text">
          <div :class="index === 0 ? 'font-color-red' : ''">
            {{ express.status }}
          </div>
          <div class="data">{{ express.time }}</div>
        </div>
      </div>
      </div>
    </div>

<!-- 未发货 -->
  <div v-else>
    <div class="logisticsCon">
            <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1" style="width:100%;">此商品暂未发货，我们正在加紧处理</span>
            </div>
            <div class="express line1">
              <span class="name">再次深感抱歉，请您耐心等待</span>
            </div>
          </div>
        </div>

      </div>
  </div>
  </div>
    </div>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";

export default {
  name: "LogisticsModul",
  data: function() {
    return {
      list:[]
    };
  },
  props:{
      data:[]
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    isshow(index)
    {
          let listData = this.list;
          let is_show = this.list[index].is_show // 先用一个变量接收一个原来的状态值
          listData.forEach((item) => {  //循环已经把所有的状态值清空了
              item.is_show = false
          })
          //(比如我当前点击的这个是打开的状态，他是true，点击的方法开始先把这个true存下来，然后接下来的循环是把所有的状态值设为false，如果你不存下来的话，你    ！状态值永远为true)
          listData[index].is_show = !is_show
          this.list = [...listData];
    },
    getData() {
        this.list = [...this.data] || [];
        this.list.forEach((item,ind) => {
            item.is_show = false;
        })
      this.$nextTick(function() {
        var copybtn = document.getElementsByClassName("copy-data");
        const clipboard = new ClipboardJS(copybtn);
        clipboard.on("success", () => {
            this.$dialog.success("复制成功");
        });
     });
    }


  }
};
</script>

<style scoped>
.alone{
    border-bottom: .1rem dashed #f5f5f5
}
.modulListTitle{
    width: 4.8rem !important;
}
.aloneWuliu{
    width:4.7rem !important;
}
.aloneWuliuInfo{
    width:4rem !important;
}
.details{
    margin:0 auto;
}
.wuLiu-InfoModul{
  padding:0 0 0 0.4rem !important;
}
.wuliu-Text {
  width:6rem !important;
}
.wuliu-detail {
  margin:0 !important;
  border-bottom-width: 0rem !important;
}


.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}

.active{
  display:none;
}
.xq{
  width:100%;
  text-align:center;
  font-size:0.2rem;
  color:#999;
  padding-bottom:0.3rem;
  position: relative;
}
.down{
    position:absolute;
    bottom:0;
    left:50%;
    transform: translate(-50%);
}
</style>
